import {Type} from '@angular/core';

export interface ComponentAsElementEntry {
  name: string;
  component: Type<any>;
}


export function ComponentAsElement(elementName: string) {
  return function (componentConstruct: any) {
    ComponentAsElement.addElement(elementName, componentConstruct, ComponentAsElement.components);
  };
}

ComponentAsElement.addElement = function (elementName, componentConstruct, components: ComponentAsElementEntry[]) {
  if (!elementName.endsWith('element')) {
    console.error(`Element's ${elementName} should have postfix 'element'`);
    return;
  }
  components.push({name: `${elementName}`, component: componentConstruct as Type<any>});
};
ComponentAsElement.components = [];
